import { Component, OnInit } from '@angular/core';
import { CheckinUserParkingRegistrationDTO } from '../../models/models.swagger.generated';
import { StringHelper } from '../string-helper';
import { parkingRoute } from '../../../core/routing/route-names';
import { ParkingProcessInfoService } from '../../services/parking-process-info.service';
import { RouterLink } from '@angular/router';


@Component({
    selector: 'app-parking-indicator',
    templateUrl: './parking-indicator.component.html',
    styleUrls: ['./parking-indicator.component.scss'],
    imports: [RouterLink]
})
export class ParkingIndicatorComponent implements OnInit {

  public parkingRoute = parkingRoute;

  public get hasActiveCheckinInfo(): boolean {
    return this.parkingProcessInfoService.parkingProcessInfos?.length > 0;
  }

  public get getIndicatorText(): string {
    let indicatorText = StringHelper.getTimeElapsed(this.parkingProcessInfoService.parkingProcessInfos?.at(0)?.activeCheckinInfo.registrationDateTime);
    if (this.parkingProcessInfoService.parkingProcessInfos?.length > 1) {
      indicatorText += ` (1/${this.parkingProcessInfoService.parkingProcessInfos.length})`;
    }
    return indicatorText;
  }

  constructor(private parkingProcessInfoService: ParkingProcessInfoService) {
  }

  public ngOnInit(): void {
    this.parkingProcessInfoService.getParkingProcessInfos()
      .subscribe(() => {});
  }

}
